import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { arrayMove } from 'react-sortable-hoc';

import {
	getRolesRequest,
	roleClick,
	changeRangeRolesRequest
} from './rolesActions';

import { getRolesSelector } from '../../reducers/roles';
import { getActiveRoleIdSelector } from '../../reducers/app';

import RolesList from '../../common/components/RolesList/RolesList';

class RoleListContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedRoleId: ''
		};

		this.handleSortEnd = this.handleSortEnd.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	componentDidMount() {
		this.props.getRolesRequest();
	}

	render() {
		const {
			roles,
			activeRoleId,
			toggleActiveRole,
			selectedRoles
		} = this.props;

		return (
			<RolesList
				roles={roles}
				sortable
				activeRoleId={activeRoleId}
				onClick={this.handleClick}
				onSortEnd={this.handleSortEnd}
			/>
		);
	}

	handleClick(role) {
		const { toggleActiveRole, activeRoleId } = this.props;

		toggleActiveRole(role.role_id, activeRoleId);
	}

	handleSortEnd({ oldIndex, newIndex }) {
		const { roles, changeRangeRolesRequest } = this.props;
		const movedRoles = arrayMove(roles, oldIndex, newIndex).map(
			role => role.role_id
		);
		changeRangeRolesRequest(movedRoles);
	}
}

function mapStateToProps(state) {
	return {
		roles: getRolesSelector(state),
		activeRoleId: getActiveRoleIdSelector(state)
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const { projectId } = ownProps.params;
	return {
		getRolesRequest: () => {
			dispatch(getRolesRequest(projectId));
		},
		toggleActiveRole: (roleId, activeRoleId) => {
			dispatch(roleClick(roleId, activeRoleId));
		},
		changeRangeRolesRequest: roles => {
			dispatch(changeRangeRolesRequest(projectId, roles));
		}
	};
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(RoleListContainer)
);



// WEBPACK FOOTER //
// ./src/js/plan/roles/RoleListContainer.js